import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/availableBalanceSummaryCard.module.scss';
import { USDFormatter } from '../../../../../utils/numbers';

function PayrollSummarySection({ grossPay, payrollDeductions, netPay }) {
    return (
        <div className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>
                Payroll Summary
            </Text>
            <div className={styles.row}>
                <Text as="span" size="s" className={styles.rowLabel}>
                    Gross Pay
                </Text>
                <Text as="span" size="s" className={styles.rowValue}>
                    {USDFormatter.format(grossPay)}
                </Text>
            </div>
            <div className={`${styles.row} ${styles.rowDivider}`}>
                <Text as="span" size="s" className={styles.rowLabel}>
                    All Payroll Deductibles
                </Text>
                <Text as="span" size="s" className={styles.rowValueAccent}>
                    -{USDFormatter.format(Math.abs(payrollDeductions))}
                </Text>
            </div>
            <div className={styles.row}>
                <Text as="span" size="s" className={styles.rowLabel}>
                    Net Pay
                </Text>
                <Text as="span" size="s" className={styles.rowValue}>
                    {USDFormatter.format(netPay)}
                </Text>
            </div>
        </div>
    );
}

export default PayrollSummarySection;
